export const offices = {
    title: "Cabinet | Cabinet | Cabinets",
    'new-office': {
        title: "Créer un nouveau cabinet",
        label: "Nouveau cabinet"
    },
    'no-active': {
        label: "Pas de cabinet actif",
        text: "Ajoutez un {0}.",
        'button-title': "Créez un nouveau cabinet",
        'button-label': "nouveau cabinet"
    },
    enabled: "activé",
    disabled: "désactivé",
    rfe: {
        title: "Facturation électronique",
        description: "Cabinet de réception de vos factures RFE.",
        label: "Cabinet par défaut",
        badge: "cabinet par défaut RFE",
        'default-label': "Choisissez un cabinet",
        confirm: {
            title: "Cabinet de réception RFE",
            content: "Souhaitez-vous définir « {name} » comme cabinet de réception de vos factures électroniques (RFE) ?",
            action: "confirmer",
            cancel: "annuler"
        },
        success: "Votre cabinet de réception des factures RFE a bien été enregistré.",
        failed: "L'enregistrement du cabinet a échoué. Veuillez réessayer."
    },
    'details-enabled': {
        owner: "Ce cabinet a été créé par {0} {1}",
        'no-owner': "Le créateur de ce cabinet n'y travaille plus",
        update: {
            title: "Modifiez les informations de ce cabinet",
            label: "modifier"
        },
        delete: {
            msg: "Voulez-vous vraiment désactiver ce cabinet ?",
            title: "Désactivation",
            label: "désactiver"
        }
    },
    'details-disabled': {
        title: "Cabinet inactif | Cabinet inactif | Cabinets inactifs",
        warning: "Les cabinets sont désactivés (et non supprimés) car ils sont potentiellement liés à des consultations, des rdv, des factures. Pour ne pas créer d'erreur, le cabinet n'est donc pas supprimé, mais n'est plus listé dans vos cabinets actifs.",
        'allow-access': "Seul le créateur de ce cabinet peut réactiver cet accès.",
        enabled: {
            title: "Activer l'accès à ce cabinet",
            label: "activer"
        }
    }
}
